import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initRelatedProducts from '../sections/product/related-products';
import initProductStickyAtc from '../components/product-sticky-atc';

ready(() => {
  initQuantityInputs();
  initProductVariants();
  initRelatedProducts();
  initProductStickyAtc();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
});
